import { render, staticRenderFns } from "./auth-2.vue?vue&type=template&id=76df627e&scoped=true"
import script from "./auth-2.vue?vue&type=script&lang=js"
export * from "./auth-2.vue?vue&type=script&lang=js"
import style0 from "./auth-2.vue?vue&type=style&index=0&id=76df627e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df627e",
  null
  
)

export default component.exports